import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import permissionGroupRoutes from '../../../components/permissionGroup/permissionGroupRoutes';

const update = createAsyncThunk(
  'thunk/permissionGroup/update',
  async (arg, thunkAPI) => {
    const response = await apiFetch(permissionGroupRoutes.api.generate.update(arg?.id), {
      body: arg?.data,
      method: 'POST',
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default update;
